import React from 'react';
import { Link } from 'react-router-dom';

const Terms = () => (
  <div style={{ maxWidth: '720px', margin: '0 auto', padding: '40px 20px 80px' }}>
    <Link to="/teams" style={{ color: '#F97316', fontSize: '13px', textDecoration: 'none', display: 'inline-block', marginBottom: '32px' }}>
      ← Back
    </Link>

    <h1 style={{ fontSize: '28px', fontWeight: 900, marginBottom: '6px' }}>Terms of Service</h1>
    <p style={{ color: '#4A5568', fontSize: '13px', marginBottom: '40px' }}>Last updated: March 2026</p>

    <Section title="1. Acceptance of Terms">
      By accessing or using Slow Rib Sports Streaming ("the Service") at slowrib.com, you agree to be bound by these Terms of Service.
      If you do not agree to these terms, please do not use the Service.
    </Section>

    <Section title="2. Description of Service">
      Slow Rib Sports Streaming is a private platform for streaming and archiving youth sports games, including baseball, softball, and soccer.
      Access to the Service is by invitation only.
    </Section>

    <Section title="3. User Accounts">
      You are responsible for maintaining the confidentiality of your account credentials.
      You agree to notify us immediately of any unauthorized use of your account.
      We reserve the right to terminate accounts at our discretion.
    </Section>

    <Section title="4. Acceptable Use">
      You agree not to:
      <ul style={{ marginTop: '10px', paddingLeft: '20px', lineHeight: 2 }}>
        <li>Share your account credentials with others</li>
        <li>Record, redistribute, or republish any streamed content without permission</li>
        <li>Use the Service for any unlawful purpose</li>
        <li>Attempt to interfere with or disrupt the Service</li>
      </ul>
    </Section>

    <Section title="5. Content">
      All video content streamed or uploaded through the Service remains the property of the respective teams and organizers.
      We do not claim ownership of any content you upload or stream.
    </Section>

    <Section title="6. Privacy">
      Your use of the Service is also governed by our{' '}
      <Link to="/privacy" style={{ color: '#F97316', textDecoration: 'none' }}>Privacy Policy</Link>,
      which is incorporated into these Terms by reference.
    </Section>

    <Section title="7. Disclaimers">
      The Service is provided "as is" without warranties of any kind, express or implied.
      We do not guarantee uninterrupted or error-free operation of the Service.
    </Section>

    <Section title="8. Limitation of Liability">
      To the fullest extent permitted by law, Slow Rib Sports Streaming shall not be liable for any indirect, incidental,
      special, or consequential damages arising out of your use of the Service.
    </Section>

    <Section title="9. Changes to Terms">
      We reserve the right to modify these Terms at any time. Continued use of the Service after changes constitutes
      acceptance of the revised Terms.
    </Section>

    <Section title="10. Contact">
      If you have questions about these Terms, please contact us at{' '}
      <a href="mailto:admin@slowrib.com" style={{ color: '#F97316', textDecoration: 'none' }}>admin@slowrib.com</a>.
    </Section>
  </div>
);

const Section = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <div style={{ marginBottom: '32px' }}>
    <h2 style={{ fontSize: '16px', fontWeight: 800, marginBottom: '10px', color: '#F0F6FC' }}>{title}</h2>
    <div style={{ fontSize: '14px', lineHeight: 1.8, color: '#8892A4' }}>{children}</div>
  </div>
);

export default Terms;
